export type FullRowsMenuMaxHeightOptions = {
  /** Tallest the menu may get. The result only exceeds it when it can't fit one row. */
  budget: number;
  /** Distance from the menu's outer top edge to the top of its first option row. */
  rowsTop: number;
  /** Height of every option row. */
  rowHeight: number;
  /** Distance from the bottom of the last option row to the menu's outer bottom edge. */
  rowsBottom: number;
};

/**
 * The tallest menu height within `budget` that shows a whole number of option
 * rows, framed exactly as a list of that length would be, so a capped menu
 * never cuts a row in half. Assumes a uniform row grid, so grouped or
 * multi-line rows can still land off a row boundary.
 */
export const fullRowsMenuMaxHeight = ({
  budget,
  rowsTop,
  rowHeight,
  rowsBottom,
}: FullRowsMenuMaxHeightOptions): number => {
  // Never below one row: a budget too small for one still shows a row.
  const visibleRows = Math.max(1, Math.floor((budget - rowsTop - rowsBottom) / rowHeight));
  return rowsTop + visibleRows * rowHeight + rowsBottom;
};
